import React, { Fragment } from 'react';
import { Responsive } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { Breakpoints } from '../../../utils';
import { assetsNoResults } from '../../../images';
import { SearchResultsPlaceholder } from '../..';
import Desktop from './Desktop';
import Mobile from './Mobile';

const Placeholder = ({ assetType }) => (
  <SearchResultsPlaceholder
    images={[assetsNoResults]}
    header={
      <FormattedMessage id="subtitle.no_results" defaultMessage="No Results" />
    }
  >
    <p>
      <FormattedMessage
        id="description.assets_empty"
        defaultMessage="There doesn't seem to be any {assetType}s associated to the criteria you selected."
        values={{ assetType }}
      />
    </p>
    <p>
      <FormattedMessage
        id="description.no_result"
        defaultMessage="Try again with new criteria or {feedback} to let us know if you can't find the {assetType} you are looking for."
        values={{
          assetType,
          feedback: (
            <a onClick={() => window.zE && window.zE.activate()}>
              use our feedback feature
            </a>
          )
        }}
      />
    </p>
  </SearchResultsPlaceholder>
);

const Body = ({ assetType, ...rest }) => {
  const props = {
    ...rest,
    placeholder: <Placeholder assetType={assetType} />
  };

  return (
    <Fragment>
      <Responsive
        as={Mobile}
        maxWidth={Breakpoints.computerBreakpoint - 1}
        {...props}
      />

      <Responsive
        as={Desktop}
        minWidth={Breakpoints.computerBreakpoint}
        {...props}
      />
    </Fragment>
  );
};

export default Body;



// WEBPACK FOOTER //
// ./src/components/AssetDownloadsTable/body/index.js